import * as React from "react";
import { forwardRef, memo } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgOutlinedRefreshIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "1rem",
	height: "1rem",
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M18.8698 7.27778H15.6096M18.8698 7.27778V3.97222M18.8698 7.27778C17.5 5.5 15.06 3.5 11.7801 3.5C7.20711 3.5 3.5 7.30558 3.5 12M5 16.7222L8.26027 16.7222M5 16.7222L5 20.0278M5 16.7222C6.36984 18.5 8.80986 20.5 12.0898 20.5C16.6627 20.5 20.3698 16.6944 20.3698 12",
		stroke: "#333333",
		strokeWidth: 1.5,
		strokeLinecap: "round"
	})]
});
const ForwardRef = forwardRef(SvgOutlinedRefreshIcon);
const Memo = memo(ForwardRef);
export default Memo;
